import React, { useContext } from 'react'
import { COLORS } from 'app/constants'
import { CButton } from '../Common'
import { SectionHeaderContainer } from './styles'
import { IconArrowNarrowRight } from '@tabler/icons'
import { CSSProperties } from 'styled-components'
import { Text, View } from 'styles/reactnative'
import { useTranslation } from 'react-i18next'
import { ThemeContext } from 'theme/ThemeProvider'

interface Iprops {
	title?: any
	content?: any
	marginLeft?: Boolean
	goTo?: any
	style?: CSSProperties
}
const SectionHeader = ({ title, content, marginLeft, goTo, style }: Iprops) => {
	const { textsilver } = useContext(ThemeContext).theme.COLORS
	const { t } = useTranslation()
	return (
		<SectionHeaderContainer>
			<View
				style={{
					alignItems: 'flex-start',
					marginLeft: marginLeft ? 0 : 40,
				}}>
				<Text size={24} style={{ fontWeight: '600', ...style }}>
					{t(title)}
				</Text>
				{content ? (
					<Text size={18} style={{ color: textsilver, marginTop: 8 }}>
						{t(content)}
					</Text>
				) : null}
			</View>
			{goTo ? (
				<CButton
					title={t('seeMore')}
					icon={
						<IconArrowNarrowRight size={18} color={COLORS.white} />
					}
					onClick={() => {}}
					style={{
						color: COLORS.white,
						padding: 5,
						fontSize: 12,
						backgroundColor: COLORS.primary,
						marginRight: marginLeft ? 0 : 35,
					}}
					textHover={COLORS.BTN_HOVER}
				/>
			) : null}
		</SectionHeaderContainer>
	)
}

export default React.memo(SectionHeader)
